import {mapGetters} from 'vuex';

export default {
    computed: {
        ...mapGetters({
            academy: 'player-profile/academy',
        }),
        isAcademyGolf() {
            return this.academy.sport_id === 1;
        },
        isAcademyBaseball() {
            return this.academy.sport_id === 2;
        },
        isAcademySoftball() {
            return this.academy.sport_id === 12;
        },
    },
    methods: {
        getSportName() {
            switch (this.academy.sport_id) {
                case 1:
                    return 'golf';
                case 2:
                    return 'baseball';
                case 12:
                    return 'softball';
            }
        }
    }
}